import { ItemUnitEnum } from '@/gen/cortado/v1/settings_pb'

interface AddonDefaultQuantityEvent {
  eventGuests?: number
  eventLength?: number
}

/**
 * Derives a default quantity for a quote add-on offer from its unit and the
 * quote's events. Per-unit add-ons always default to 1. Falls back to 1
 * whenever event data is missing or zero. Mirrors `portal/src/lib/addon-defaults.ts`
 * (the customer-facing default used before quantity became tenant-authored).
 */
export function getDefaultAddonQuantity(unit: ItemUnitEnum, events: AddonDefaultQuantityEvent[]): number {
  switch (unit) {
    case ItemUnitEnum.ITEM_UNIT_PER_HOUR: {
      const hours = events.reduce((sum, event) => sum + (event.eventLength ?? 0), 0)
      return hours > 0 ? hours : 1
    }
    default:
      return 1
  }
}
